import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-flatten-icon',
  templateUrl: './design-flatten.component.html'
})
export class DesignFlattenComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
